export default __webpack_public_path__ + "static/media/smile-photo.9d70af8e.webp";